var BudgetStrings = {
    maxAmountValidationMessage: function (max) {
        return "Team plans have a maxmium spending limit of $" + max + ". For higher spending limits, contact sales to upgrade to the Enterprise plan.";
    },
    spendingLimitFieldLabel: function (max) {
        return "Spending limit (up to  $" + max + " per person)";
    },
    spendingLimitTooltipText: function (max) {
        return "You have a limit of $" + max + " per person for the Small Team plan. To increase the spending limit per person, contact sales to upgrade to the Corporate Ordering plan.";
    },
    budgetsLimitSubtitle: function (noOfBudgets, maxBudgets) {
        return noOfBudgets + " out of " + maxBudgets;
    },
    budgetsLimitSubtitleTooltip: function (noOfBudgets, maxBudgets) {
        return "You've added " + noOfBudgets + " out of " + maxBudgets + " meal budgets allowed by your  Team plan. To add more members, contact sales to upgrade to the Enterprise plan.";
    },
    budgetLimitSalesModalTitle: function (maxBudgets) {
        return "You've reached your Team plan limit of " + maxBudgets + " meal budgets";
    },
    budgetSalesModalDescription: function () {
        return 'Delete one of your existing meal budgets or contact sales to upgrade to the Enterprise plan which allows unlimited meal budgets.';
    },
    budgetSalesModalContactSalesButtonText: function () { return 'Contact Sales'; },
    budgetSalesModalCancelButtonText: function () { return 'Cancel'; },
};
export default BudgetStrings;
